import React from 'react';
import PropTypes from 'prop-types';
import RemoveLoadingScreen from '@/pages/RemoveLoadingScreen';
import ScrollToTop from '@/components/ScrollToTop';
import logo from '@communityshare/ui-shared/images/logo.png';
import { Helmet } from 'react-helmet-async';
import useIntercom from '@/hooks/useIntercom';

export default function Layout(props) {
  const { children } = props;

  useIntercom();

  return (
    <div className="bg-white">
      <Helmet>
        <title>Setup</title>
      </Helmet>
      <ScrollToTop />
      <RemoveLoadingScreen/>
      <div className="flex flex-col lg:flex-row h-16 lg:h-screen">
        <div className="flex items-center justify-center bg-gradient-to-b from-cs-yellow-100 to-cs-yellow-300 px-16 h-16 py-8 lg:h-screen">
          <img src={logo} className="w-8 lg:w-40 xl:w-64 filter drop-shadow-md mx-4" alt="logo" />
        </div>
        <div className="flex-1 flex flex-col h-auto lg:h-100 lg:overflow-scroll">
          {children}
        </div>
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};
